import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Text } from 'components/common'
import { FC } from 'react'
import { Events } from './types'

interface EventBlockProps {
  eventInfo: Events
}

// イベントをクリックした時に表示されるポップの中身
const EventBlock: FC<EventBlockProps> = ({ eventInfo }) => {
  const startDate = new Date(eventInfo.start)
  const endDate = new Date(eventInfo.end)

  // 開始時間・終了時間を成型
  const startYear = startDate.getFullYear()
  const startMonth = startDate.getMonth() + 1
  const startDay = startDate.getDate()
  const startHour = startDate.getHours()

  const formattedStart = `${startYear}年${startMonth}月${startDay}日${startHour}:00`

  const endYear = endDate.getFullYear()
  const endMonth = endDate.getMonth() + 1
  const endDay = endDate.getDate()
  const endHour = endDate.getHours()

  const formattedEnd = `${endYear}年${endMonth}月${endDay}日${endHour}:00`

  return (
    <>
      <div>
        {/* TODO：同じようなdivが連続しているので改善の余地あり */}
        <div>
          <p className=" font-bold border-solid border-b-2 border-black">
            <ExclamationCircleOutlined />
            <span> 施設</span>
          </p>
          <p>
            <Text>{eventInfo.productName}</Text>
          </p>
        </div>
        <div>
          <p className=" font-bold border-solid border-b-2 border-black">
            <ExclamationCircleOutlined />
            <span> 区分</span>
          </p>
          <p>
            <Text>{eventInfo.purpose}</Text>
          </p>
        </div>
        <div>
          <p className=" font-bold border-solid border-b-2 border-black">
            <ExclamationCircleOutlined />
            <span> 期間</span>
          </p>
          <p>
            <Text>
              {formattedStart} ～ {formattedEnd}
            </Text>
          </p>
        </div>
        <div>
          <p className=" font-bold border-solid border-b-2 border-black">
            <ExclamationCircleOutlined />
            <span> 人数</span>
          </p>
          <p>
            <Text>{eventInfo.numberOfPeople}人</Text>
          </p>
        </div>
      </div>
    </>
  )
}

export default EventBlock
